//#region types
import { AuthEnums } from "models/enums";
//#endregion
import useAPIClientHelper from "./useAPIClientHelper";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

function useSupportService() {
  const { apiClientInstance } = useAPIClientHelper();

  const trackEvent = (diagnosticsPost: WintSuperkollAPIModel.DiagnosticsPost) => {
    return apiClientInstance(AuthEnums.AuthType.Company).DiagnosticsClient.TrackEvent(diagnosticsPost);
  };

  return {
    trackEvent,
  };
}

export default useSupportService;
